<template>
  <MultiFileDirectUploader
    :file-badge-position="showOnTop"
    :existing-files="files"
    :accept="accept"
    :on-file-uploaded="onFileUploaded"
    :on-file-removed="onFileRemoved"
    :on-file-upload-progress="onFileUploadProgress"
  >
    <a class="add-documents">
      <i class="fa fa-paperclip" />
      {{ I18n.t('components.commentable.remark_comment_form.upload') }}
    </a>
  </MultiFileDirectUploader>
</template>

<script>
import MultiFileDirectUploader from '@app/shared/vue/components/direct-upload/multi-file-direct-uploader'
import { SHOW_ON_TOP } from '@app/shared/vue/components/direct-upload/constants'

export default {
  name: 'MultiFileUploadWrapper',

  components: {
    MultiFileDirectUploader,
  },

  data: function () {
    return {
      onFileUploaded: this.onFileUploaded || (() => {}),
      onFileRemoved: this.onFileRemoved || (() => {}),
      onFileUploadProgress: this.onFileUploadProgress || (() => {}),
      accept: this.accept || '',
      files: this.files || {},
    }
  },

  computed: {
    showOnTop() {
      return SHOW_ON_TOP
    },
  },
}
</script>
